module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB2002-38feff1d1bbaab0eb0f7ea0b1a54d9fe.png";